import React, { useState } from "react";
import { Drawer, Box, Typography, IconButton, Divider } from "@mui/material";
import ButtonBlue from "../buttonBlue";
import CloseIcon from "@mui/icons-material/Close";
import { useMediaQuery } from "@mui/material";

const RightDrawer = ({
  header,
  children,
  buttonLabel,
  buttonIcon,
  isDrawerOpen,
  setIsDrawerOpen,
}) => {
  const isDrawerFullWidthScreen = useMediaQuery((theme) =>
    theme.breakpoints.down("sm")
  );

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsDrawerOpen(open);
  };

  return (
    <div>
      {buttonLabel || buttonIcon ? (
          <ButtonBlue
            variant="contained"
            startIcon={buttonIcon}
            onClick={toggleDrawer(true)}
          >
            {buttonLabel}
          </ButtonBlue>
        ) : null}
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
        sx={{ zIndex: 1300 }}
      >
        <Box
          sx={{
            width: {
              xs: "100vw",
              sm: 598,
            },
            position: "relative",
          }}
          role="presentation"
        >
          {isDrawerFullWidthScreen && (
            <IconButton
              onClick={toggleDrawer(false)}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
          <Typography sx={{ padding: "16px" }}>{header}</Typography>
          <Divider />
          <Box sx={{ padding: "24px" }}>{children}</Box>
        </Box>
      </Drawer>
    </div>
  );
};

export default RightDrawer;
